import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
export const rules = {
 
  name: [
      { required: true, message: 'Пожалуйста, введите название ', trigger: 'change' }      
  ],
}
